import { useAppSelector } from "Store/hooks";
import { selectOrganization } from "../redux/selectors";
import { columns } from "./columns/columns";
import { Table } from "antd";

const OrganizationsTable = () => {
  const tenantsList = useAppSelector(selectOrganization);
  return (
    <Table
      style={{ padding: "0px" }}
      columns={columns}
      dataSource={tenantsList}
    />
  );
};
export default OrganizationsTable;
